import {
  CommonBG,
  HeaderOptions,
  StageSelect,
} from '@riddler-co-jp/specc-ui-components';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import {
  InstructionColor,
  InstructionLogo,
} from '../../../lib/instructionSettings';

const headerOptions: HeaderOptions = {
  hideHomeButton: true,
  hideSettingButton: true,
};

interface SelectStageProps {}
export const SelectStage: React.FC<SelectStageProps> = () => {
  const navigate = useNavigate();
  const { trainingId } = useParams<'trainingId'>();
  return (
    <CommonBG withHeader headerOptions={headerOptions} withFooter>
      <StageSelect
        onBack={() => navigate(`/${trainingId}/`)}
        onFinish={() => navigate(`/${trainingId}/finish`)}
        stages={[
          {
            name: '"理由"を探せ\n-Whyツリー-',
            path: '/' + trainingId + '/energy1/introduction',
          },
          {
            name: '"方法"を探せ\n-Howツリー-',
            path: '/' + trainingId + '/energy2/page1',
          },
        ]}
        color={InstructionColor}
        logo={InstructionLogo}
      />
    </CommonBG>
  );
};
export default SelectStage;
